import axios from 'axios';
import cfac22 from 'js/library/utils/cfac22';

export async function uploadFiles(folderName, file, useDateNow) {
  const result = await axios.post(
    `${cfac22('API_HOST_V2')}/storage/upload/`,
    { folderName, file, useDateNow },
    {
      headers: { 'Content-Type': 'application/json', 'Full-Url': window.location.href },
      withCredentials: true,
    }
  );

  return result.data.result;
}
